<template>
  <div>
    <el-form :model="searchItem" inline size="small">
      <el-form-item label="ID">
        <el-input v-model.trim="searchItem.id" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="应用名称">
        <el-select v-model="searchItem.app_store_id" filterable clearable>
          <el-option v-for="item in tableOperate.appList" :key="item.id" :value="item.id" :label="`${item.name}(${item.code})`"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应用数量">
        <el-input v-model.trim="searchItem.quantity" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="primary" @click="reset" plain>重置</el-button>
      </el-form-item>
    </el-form>
    <vue-table :table-data="tableData" :count-list="countList">
      <template slot="operateBar">
        <el-button size="small" type="primary" @click="add">下单</el-button>
      </template>
      <template slot="app_store_id" slot-scope="{row}">
        <span>{{formatId(row.app_store_id, tableOperate.appList)}}</span>
      </template>
      <template slot="duration" slot-scope="{row}">
        <span>{{formatDuration(row)}}</span>
      </template>
      <template slot="amount" slot-scope="{row}">
        <span>{{convertYuan(row.amount)}}￥</span>
      </template>
      <template slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="150">
          <template slot-scope="{row}">
            <el-button type="text" @click="doExport(row)" :disabled="row.status !== 1">导出</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <vue-pagination :paging-data="pagingData" @getData="getData" ref="paging"/>
    <table-operate v-if="tableOperate.visible" :dialog-data="tableOperate" @getData="getData"/>
  </div>
</template>

<script>
import {PagingData} from "@mixins"
import {appPeriod,orderStatus} from "@utils/formatList";
import TableOperate from "./dialog/TableOperate"
export default {
  name: "index",
  mixins: [PagingData],
  components: {TableOperate},
  data() {
    return {
      appPeriodObj: this.formatToObj(appPeriod),
      searchItem: {
        id: "",
        app_store_id: "",
        quantity: "",
      },
      commitItem: null,
      countList: [
        {name: "总记录", count: 0},
      ],
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "ID", property: "id"},
          {label: "应用名称", property: "app_store_id"},
          {label: "应用数量", property: "quantity"},
          {label: "应用有效时长", property: "duration"},
          {label: "代金券数量", property: "count"},
          {label: "代金券金额", property: "amount"},
          {label: "下单时间", property: "create_at"},
          {label: "订单描述", property: "reason"},
          {label: "状态", property: "status", format: orderStatus},
        ],
      },
      tableOperate: {visible: false, title: "", row: null, appList: [], width: 600},
    }
  },
  methods: {
    async doExport(row) {
      const nv = {
        order_id: row.id
      }
      const res = await this.$Http.exportVoucherOrder(nv);
      if (res?.data) {
        const content = res.data || "";
        let blob = new Blob(["\ufeff" + content], { type: "text/plain", endings: "transparent" });
        this.downloadFile(`voucher-${this.getCurrentTime()}`, blob, ".csv");
      }
    },
    formatId(id, list) {
      return list.find(item => item.id === id)?.name || "-"
    },
    formatDuration(row) {
      return `${row.duration}${this.appPeriodObj[row.period]}`
    },
    add() {
      this.tableOperate.visible = true;
      this.tableOperate.title = "下单";
      this.tableOperate.row = null;
    },
    search() {
      this.commitItem = {...this.searchItem};
      this.pagingData.currentPage = 1;
      this.getData();
    },
    reset() {
      Object.keys(this.searchItem).forEach(key => this.searchItem[key] = "");
      this.search();
    },
    async getData() {
      let nv = {
        page: this.pagingData.currentPage,
        limit: this.pagingData.pageSize,
      };
      this.copyObjValue(nv, this.commitItem);
      const res = await this.$Http.getAppVoucherOrder(nv);
      if (res?.data) {
        let total = +res.data.total || 0;
        this.pagingData.total = total;
        this.countList[0].count = total;
        this.tableData.tableList = res.data.list || [];
      }
    },
    async getApp() {
      const res = await this.$Http.getAppOption();
      if (res?.data) {
        this.tableOperate.appList = res.data || [];
      }
    },
  },
  mounted() {
    this.getApp();
    this.getData();
  }
}
</script>

<style scoped lang="scss">

</style>

